module.exports = __webpack_public_path__ + "9779d9a1/img/at-icon.5d6fc5d8.svg";